import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import { AuthContext } from '../context/AuthContext';
import CartItem from '../components/cart/CartItem';
import CartSummary from '../components/cart/CartSummary';
import { ShoppingBagIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const Cart = () => {
  const { cartItems, updateQuantity, removeFromCart, cartTotal } = useContext(CartContext);
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleCheckout = () => {
    if (!isAuthenticated) {
      navigate('/login', { state: { from: '/checkout' } });
    } else {
      navigate('/checkout');
    }
  };

  if (cartItems.length === 0) {
    return (
      <div className="min-h-[60vh] bg-white flex items-center justify-center px-6 py-16">
        <div className="text-center max-w-sm">
          <ShoppingBagIcon className="h-16 w-16 text-gray-300 mx-auto mb-5" />
          <h1 className="text-xl font-light tracking-tight text-gray-900 mb-2">
            Your cart is empty
          </h1>
          <p className="text-sm text-gray-400 mb-8">
            Looks like you haven't added any items yet.
          </p>
          <Link 
            to="/products" 
            className="inline-flex items-center gap-2 text-sm text-gray-900 border-b border-gray-300 hover:border-gray-900 transition pb-0.5"
          >
            <ArrowLeftIcon className="h-3 w-3" />
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
      <div className="flex items-center justify-between mb-8 lg:mb-12">
        <h1 className="text-xl lg:text-2xl font-light tracking-tight text-gray-900">
          Shopping Cart
          <span className="text-sm text-gray-400 font-normal ml-2">
            ({cartItems.length} items)
          </span>
        </h1>
        <Link 
          to="/products" 
          className="text-xs text-gray-400 hover:text-gray-900 transition flex items-center gap-1"
        >
          <ArrowLeftIcon className="h-3 w-3" />
          Continue shopping
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
        {/* Cart Items */}
        <div className="lg:col-span-2">
          <div className="border-t border-gray-100">
            {cartItems.map((item, index) => (
              <CartItem
                key={`${item.id}-${item.size}-${item.color}`}
                item={item}
                onUpdateQuantity={updateQuantity}
                onRemove={removeFromCart}
              />
            ))}
          </div>
        </div>

        {/* Summary */}
        <div className="lg:col-span-1">
          <CartSummary subtotal={cartTotal} onCheckout={handleCheckout} />
        </div>
      </div>
    </div>
  );
};

export default Cart;